// extracted by mini-css-extract-plugin
export default {"wrapper":"PatientDialog_wrapper__CR9CG"};